<template>
  <BaseBadge :variant="statusVariant" size="sm">
    {{ statusLabel }}
  </BaseBadge>
</template>

<script>
import { defineComponent, computed } from 'vue';
import BaseBadge from '@/components/base/BaseBadge.vue';

export default defineComponent({
  name: 'SaleStatusBadge',
  components: {
    BaseBadge
  },
  props: {
    sale: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    // Vérifier si la vente est impayée (pas de payments)
    const isUnpaid = computed(() => {
      return !props.sale.payments || props.sale.payments.length === 0;
    });

    // Vérifier si la vente a une facture associée
    const hasInvoice = computed(() => {
      return props.sale.sale_invoice_id !== null && props.sale.sale_invoice_id !== undefined;
    });

    const statusLabel = computed(() => {
      const status = props.sale.status;

      // Si la vente a une facture, afficher "Facturée"
      if (hasInvoice.value) {
        return 'Facturée';
      }

      // Labels standards basés sur le status
      const labels = {
        'pending': 'En attente',
        'completed': 'Complétée',
        'paid': 'Payée',
        'partial_paid': 'Paiement partiel',
        'refunded': 'Remboursée',
        'partial_refund': 'Remb. partiel'
      };

      return labels[status] || status;
    });

    const statusVariant = computed(() => {
      const status = props.sale.status;

      if (hasInvoice.value) {
        return 'info';
      }

      const variants = {
        'pending': 'warning',
        'completed': 'success',
        'paid': 'success',
        'partial_paid': 'info',
        'refunded': 'danger',
        'partial_refund': 'warning'
      };

      return variants[status] || 'gray';
    });

    return {
      statusLabel,
      statusVariant,
      isUnpaid,
      hasInvoice
    };
  }
});
</script>
